import store from '../../../store';

const hasPermission = (permission: string) => {
  const state = store.getState();
  return state.home.permissions?.includes(permission);
};

export default hasPermission;
